import React, { FormEventHandler, FocusEventHandler } from 'react';
import { CHANGE_NAME_DOC_ISSUER } from '../../../constants/fieldNames';

import FIO from '../FIO/FIO';
import { CHANGE_NAME } from '../../../constants/child';
import { Field } from '../../../declarations/widget-ums';
import TextField from '../TextField/TextField';
import { getPersonPlaceholder } from '../../../helpers/getPlacelholder';

export const ChangeFIOFieldNames = {
  changedName: 'changedName',
  changedSurname: 'changedSurname',
  changedPatronimic: 'changedPatronimic',
  changeNameDocIssuer: 'changeNameDocIssuer',
};

export const ChangeFIOFields = [
  ChangeFIOFieldNames.changedSurname,
  ChangeFIOFieldNames.changedName,
  ChangeFIOFieldNames.changedPatronimic,
];

export interface ChangeFIOProps {
  changeName: Field<CHANGE_NAME | null>;
  changedName: Field<string>;
  changedSurname: Field<string>;
  changedPatronimic: Field<string>;
  changeNameDocIssuer: Field<string>;
  isChangedPatronymicAbsent: Field<boolean>;
}

interface Props extends ChangeFIOProps {
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
}

function ChangeFIO({
  changeName,
  onChange,
  onBlur,
  changedName,
  changedPatronimic,
  changedSurname,
  changeNameDocIssuer,
  isChangedPatronymicAbsent,
}: Props) {
  if (changeName.value !== CHANGE_NAME.notMatch) return null;
  return (
    <div className="StepContentBlock ChangeFIO">
      <FIO
        nameFields={ChangeFIOFields}
        onChange={onChange}
        onBlur={onBlur}
        {...{ changedName, changedPatronimic, changedSurname }}
        isPatronymicAbsent={isChangedPatronymicAbsent}
        inMarriage={false}
      />
      <div className="PguFormGrid__row">
        <TextField
          className="PguFormGrid_col"
          placeholder={getPersonPlaceholder(CHANGE_NAME_DOC_ISSUER)}
          inputProps={{
            name: CHANGE_NAME_DOC_ISSUER,
            ...changeNameDocIssuer,
            onChange,
            onBlur,
            maxLength: 200,
          }}
        />
      </div>
    </div>
  );
}

export default ChangeFIO;
